
<div class="border-solid border-b border-gray-300 bg-gray-100">
  <span class="text-gray-900 p-3 block text-md font-normal">{{report.poi.name}}</span>
</div>

<div [ngSwitch]="selectedIndex">
  <div *ngSwitchCase="0">
    <div class="details-list t-60 p-3 mt-1">
      <div title="Visites">Visites</div>
      <div>{{report.nb_visits}} fois {{report.visits_numbers}}</div>
      <div title="Durée d'arrêts">Durée d'Arrêts Totale</div>
      <div>{{report.visit_duration_human}}</div>
      <div title="Distance">Distance Parcourue</div>
      <div>{{report.metrics.length_in_km | number}} km</div>
      <div title="Vitesse Moyenne">Vitesse Moyenne</div>
      <div>{{report.metrics.speed_avg | number}}  km/h</div>
      <div title="Vitesse Maximale">Vitesse Maximale</div>
      <div>{{report.metrics.speed_max | number}}  km/h</div>
      <div title="Consomation Carburant Totale">Consomation Carburant Totale</div>
      <div>{{report.metrics.fuel_total_consumption | number}} L</div>
      <div title="Consomation Carburant Par Heure">Consomation Carburant Par Heure</div>
      <div>{{report.metrics.fuel_hourly_consumption_rate_avg | number}} L/h</div>
      <div title="Temperature Carburant">Temperature Carburant</div>
      <div>{{report.metrics.fuel_temperature_avg | number}} °C</div>
    </div>
  </div>
  <div *ngSwitchCase="1">
    <dx-data-grid
      [dataSource]="report.visits"
      [showBorders]="false"
      [showColumnLines]="true"
      [showRowLines]="true"
      [errorRowEnabled]="false"
      [showColumnHeaders]="false"
      [columnAutoWidth]="true"
      [remoteOperations]="{ grouping: false }">
      <dxi-column dataType="string" alignment="left" cellTemplate="cellTemplate"></dxi-column>
      <div *dxTemplate="let cell of 'cellTemplate'">
        <div class="flex flex-row w-full">#{{cell.data.visit_number}} {{cell.data.enter_time | date :'shortTime'}}
          - {{cell.data.exit_time | date :'shortTime'}}, {{cell.data.visit_duration_human}}, ({{cell.data.enter_time | date :'shortDate'}})</div>
      </div>
      <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>
      <div *dxTemplate="let item of 'detail'">
        <div class="details-list t-60">
          <div title="Durée d'arrêts">Durée d'Arrêts</div>
          <div>{{item.data.visit_duration_human}}</div>
          <div title="Distance">Distance Parcourue</div>
          <div>{{item.data.diff_metrics.length_in_km | number}} km</div>
          <div title="Vitesse Moyenne">Vitesse Moyenne</div>
          <div>{{item.data.diff_metrics.speed_avg | number}}  km/h</div>
          <div title="Vitesse Maximale">Vitesse Maximale</div>
          <div>{{item.data.diff_metrics.speed_max | number}}  km/h</div>
          <div title="Consomation Carburant Totale">Consomation Carburant</div>
          <div>{{item.data.diff_metrics.fuel_total_consumption | number}} L</div>
          <div title="Consomation Carburant Par Heure">Consomation Carburant Par Heure</div>
          <div>{{item.data.diff_metrics.fuel_hourly_consumption_rate_avg | number}} L/h</div>
          <div title="Temperature Carburant">Temperature Carburant</div>
          <div>{{item.data.diff_metrics.fuel_temperature_avg | number}} °C</div>
        </div>
      </div>
    </dx-data-grid>
  </div>
</div>

<div class="border-t border-gray-300 border-solid">
  <dx-tabs
    [dataSource]="tabs"
    [(selectedIndex)]="selectedIndex"
    [width]="400"
    [scrollByContent]="true"
    [showNavButtons]="true"
  ></dx-tabs>
</div>
